module.exports = __webpack_public_path__ + "static/vending-275ecca3d8397b73a6158ec9677ef99b.jpg";